import { responseError } from '@/utils/errors';
import findResult from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import withDraft from '@/utils/draftHelper';
import actions from '../constants';
import { findAllDatasets } from '../../state/shared';
import handleDatasetSubscribeSuccess from './state';

const toggleDatasetSubscribe = withDraft((draft, { code }) => {
  findAllDatasets(draft, { items: [{ code }] }).forEach((category) => {
    const item = findResult(draft.datasets, category, code);
    item.subscriptionsStatus = states.PENDING;
  });
});

const toggleDatasetSubscribeSuccess = withDraft((draft, action) => {
  handleDatasetSubscribeSuccess(draft, action);
});

const toggleDatasetSubscribeError = withDraft((draft, action) => {
  findAllDatasets(draft, { items: [{ code: action.code }] }).forEach((category) => {
    const item = findResult(draft.datasets, category, action.code);
    item.subscriptionsStatus = states.ERROR;
    item.subscriptionsErrors = [responseError(action)];
  });
});

export default {
  [actions.TOGGLE_DATASET_SUBSCRIBE]: toggleDatasetSubscribe,
  [actions.TOGGLE_DATASET_SUBSCRIBE_ERROR]: toggleDatasetSubscribeError,
  [actions.TOGGLE_DATASET_SUBSCRIBE_SUCCESS]: toggleDatasetSubscribeSuccess,
};
